module.exports = __webpack_public_path__ + "static/img/hua4.3b0121b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua4.png
// module id = qqWs
// module chunks = 22